import styles from "./styles.module.scss";
import Section from "../../components/Section";
import img3 from "../../images/3.png";
import ps_icon from "../../graphics/ps_icon.svg";
import raster1 from "../../images/raster_1.png";
import raster2 from "../../images/raster_2.png";

const Raster = () => {
  return (
    <Section>
      <div className={styles.container}>
        <div className={styles.title}>
          <div>
            <img src={img3} alt="3" />
          </div>
          <h1>РАСТРОВАЯ ГРАФИКА</h1>
        </div>

        <div className={styles.content}>
          <div className={styles.task}>
            <h4 className={styles.sub_title}>Задача</h4>
            <p className={styles.text}>
              Для учебного проекта необходимо было повторить иллюстрации
              понравившихся художников.
            </p>
          </div>

          <div className={styles.execution}>
            <div>
              <h4 className={styles.sub_title}>Реализация</h4>
              <div className={styles.icon_text}>
                <div>
                  <img src={ps_icon} alt="Adobe Photoshop" />
                </div>
                <p>Adobe Photoshop</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.images}>
          <div>
            <img src={raster1} alt="" />
          </div>
          <div>
            <img src={raster2} alt="" />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Raster;
